import { TFunction } from 'i18next';
import { AllExpensesOptions } from '../../forms/Denmark/LoanApplication/steps/Step5/config/allExpensesOptions';

const getValueText = ({
  options,
  category,
  value,
}: {
  options: AllExpensesOptions;
  category: keyof AllExpensesOptions;
  value: number;
}) => {
  const option = options[category].find((el) => parseInt(el.value) === value);
  return option ? option.text : '';
};

export const getExpenses = ({
  categories,
  options,
  values,
  t,
}: {
  categories: (keyof AllExpensesOptions)[];
  options: AllExpensesOptions;
  values: number[];
  t: TFunction<string, never>;
}) =>
  categories.map((category, index) => {
    const value = getValueText({
      options,
      category,
      value: values[index],
    });

    const label = t(
      `${category.charAt(0).toUpperCase() + category.slice(1)}.label`
    );

    return {
      label,
      value,
    };
  });
